var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspEarth = function SvgUspEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 22,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0689 7L44.1916 26.3173C44.0813 26.6192 44.0455 26.9433 44.0872 27.2619C44.1289 27.5806 44.2469 27.8845 44.4312 28.1478C44.6155 28.4112 44.8606 28.6261 45.1457 28.7745C45.4308 28.9228 45.7475 29.0002 46.0689 29H58.0689C58.3905 29.0006 58.7075 28.9236 58.993 28.7754C59.2785 28.6272 59.5239 28.4123 59.7085 28.1489C59.8931 27.8856 60.0113 27.5815 60.0532 27.2626C60.095 26.9437 60.0593 26.6194 59.9489 26.3173L52.0689 7Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0693 29V37",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0693 29L22.584 16.6506C22.7718 16.4426 23.0011 16.2763 23.2572 16.1625C23.5133 16.0486 23.7904 15.9898 24.0707 15.9898C24.3509 15.9898 24.628 16.0486 24.8841 16.1625C25.1402 16.2763 25.3696 16.4426 25.5573 16.6506L36.0693 29",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9279 37C60.2018 37.0001 60.4728 37.0565 60.7241 37.1655C60.9753 37.2746 61.2016 37.434 61.3888 37.6339C61.576 37.8339 61.7202 38.0701 61.8125 38.328C61.9047 38.5859 61.9431 38.86 61.9253 39.1333C61.381 46.6983 57.9919 53.7765 52.4397 58.9436C46.8876 64.1107 39.5845 66.9832 31.9999 66.9832C24.4154 66.9832 17.1123 64.1107 11.5601 58.9436C6.00795 53.7765 2.61879 46.6983 2.07458 39.1333C2.05672 38.8602 2.09503 38.5864 2.18714 38.3286C2.27926 38.0709 2.42322 37.8348 2.61014 37.6349C2.79706 37.435 3.02297 37.2755 3.27393 37.1663C3.52488 37.0571 3.79556 37.0005 4.06925 37H59.9279Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 60.4453L16.0005 47H18.8778C19.4857 46.9999 20.0856 46.8613 20.6319 46.5947C21.1781 46.3281 21.6565 45.9404 22.0305 45.4613C22.4046 44.9821 22.6645 44.424 22.7905 43.8293C22.9165 43.2346 22.9053 42.619 22.7578 42.0293L21.4965 37",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6665 37L49.4425 47.6667C49.5984 48.6006 50.0806 49.449 50.8033 50.0608C51.526 50.6727 52.4423 51.0083 53.3892 51.008H58.5225",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspEarth;